import styled from 'styled-components';

export const CreateCardButton = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;
  text-align: left;
  padding: 0.85rem 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  border: 2px dashed ${({ theme }) => theme.colors.border.light};
  background: ${({ theme }) => `${theme.colors.primary}06`};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};
  transition:
    border-color 0.15s ease,
    background 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => `${theme.colors.primary}10`};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const IconWrap = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  background: ${({ theme }) => `${theme.colors.primary}18`};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.1rem;
`;

export const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
`;

export const Title = styled.span`
  font-size: 0.92rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Description = styled.span`
  font-size: 0.8rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
